import moment from "moment";
import { useCallback, useRef, useState } from "react";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintPeryataanDevelover = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);
    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;

      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-item"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocPeryataanDevelover = ({ innerRef, item, companyName, companyValue }) => {
  const handleValidDate = (date) => {
    return moment(date).format("MMM D, YYYY");
  };

  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  return item === undefined || item === null ? (
    <></>
  ) : (
    <div
      className="d-none"
      style={{
        overflow: "scroll",
        //backgroundColor: "blue"
      }}
    >
      <div ref={innerRef} className="bg-white" style={{ padding: "40px 80px 40px 80px" }}>
        <div
          style={{
            textAlign: "center",
            fontSize: "18px",
            fontWeight: "bold",
          }}
        >
          SURAT PERNYATAAN DEVELOPER
        </div>

        <div style={{ padding: "10px" }}>
          <div style={{ marginTop: "10px" }}>Yang bertanda tangan di bawah ini:</div>
          <table style={{ marginTop: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td>:</td>
                <td>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td>Jabatan</td>
                <td>:</td>
                <td>{item.sls_appl?.job_position ?? "-"}</td>
              </tr>
              <tr>
                <td>Nama Developer</td>
                <td>:</td>
                <td>{companyName}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat</td>
                <td>:</td>
                <td>{item.sls_appl?.address ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ marginTop: "10px" }}>Dengan ini menyatakan bahwa debitur:</div>{" "}
          <table style={{ marginTop: "10px", marginBottom: "10px", borderCollapse: "collapse", tableLayout: "fixed", lineHeight: "1" }}>
            <tbody>
              <tr>
                <td style={{ verticalAlign: "top", width: "180px" }}>Nama Lengkap</td>
                <td style={{ width: "15px" }}>:</td>
                <td>{item.sls_appl?.name ?? "-"}</td>
              </tr>
              <tr>
                <td>No. KTP</td>
                <td>:</td>
                <td>{item.sls_appl?.identity ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ verticalAlign: "top" }}>Alamat Perumahan</td>
                <td>:</td>
                <td>{item.sales_branch?.branch_address[0]?.description ?? "-"}</td>
              </tr>
            </tbody>
          </table>
          <p>Melaksanakan akad kredit di Bank BTN dengan kondisi saat ini fasilitas SBUM akan dibayarkan apabila telah dapat ditagihkan dan sesuai dengan ketentuan pada PKS SBUM TA 2025. Sehubungan dengan hal tersebut kami menyatakan tidak akan mengaitkan pembayaran SBUM debitur dimaksud kepada Bank BTN.</p>
          <p>Demikian surat pernyataan ini dibuat dengan sebenar-benarnya tanpa paksaan dari pihak manapun.</p>
        </div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <table
            style={{
              borderCollapse: "collapse",
              width: "70%",
              border: "1px solid black",
              tableLayout: "fixed",
            }}
          >
            <tbody>
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    width: "50%",
                    textAlign: "center",
                  }}
                >
                  <br />
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "8px 12px",
                    verticalAlign: "top",
                    textAlign: "center",
                  }}
                >
                  ......................, ................ 20...
                  <br />
                  <small style={{ fontSize: "12px" }}>Kota/Kabupaten, tanggal bulan tahun</small>
                  <br />
                  <span style={{ fontWeight: "bold" }}>Yang Menyatakan,</span>
                  <br /> <br /> <br /> <br />
                </td>
              </tr>

              {/* Kotak Materai */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "28px 12px 8px 12px",
                    verticalAlign: "top",
                  }}
                >
                  {/* Kosong untuk tanda tangan kiri */}
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    textAlign: "center",
                    verticalAlign: "middle",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      border: "1px solid black",
                      width: "140px",
                      height: "80px",
                      top: "-50px",
                      left: "50%",
                      padding: "10px",
                      fontSize: "12px",
                      textAlign: "center",
                      position: "absolute",
                      transform: "translateX(-50%)",
                      backgroundColor: "white",
                    }}
                  >
                    Meterai
                    <br />
                    Rp. 10.000,-
                  </div>
                </td>
              </tr>

              {/* Baris tanda tangan */}
              <tr>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  <br />
                  <br />
                  <br />
                </td>
                <td
                  style={{
                    border: "1px solid black",
                    padding: "40px 12px 8px 12px",
                    verticalAlign: "bottom",
                    textAlign: "center",
                  }}
                >
                  ( ..................................................... )
                  <br />
                  Nama Lengkap Pembuat Pernyataan dan Stempel <br /> Developer
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <p>*) coret salah yang tidak perlu</p>
      </div>
    </div>
  );
};
